<template lang="pug">
.subscribe-modal
  subscribe-later-modal(v-model="subscribeLater" @continueLater="dialog = false")
  edit-member-modal(v-if="openEditMemberDialog" :open.sync="openEditMemberDialog" :company="company" :count="totalAllowedMember")
  edit-form-modal(v-if="openEditFormDialog" :open.sync="openEditFormDialog" :company="company" :count="totalAllowedForm")
  y-dialog(v-model="dialog" :max-width="step == 0? '400px' : '600px'" persistent scrollable :fullscreen="step == 0? false : $vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4(v-if="company.status != 'Active' && company.contract")
        .h6.textColor--text Account Suspended
      v-card-title.px-4(v-else)
        v-layout
          eva-icon.mr-4(v-if="step > 0 && company.status === 'Trial'" name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" @click="dialog = false")
          .h6.textColor--text(v-if="step == 0") {{ windowTitle }}
          .h6.textColor--text(v-else) Subscription
      v-card-text.px-4
        .stepper(v-if="step > 0 && step < 5")
          v-divider.mt-8.mb-n5
          v-layout.mb-8
            div.px-3.basic100.text-center(v-if="index > 0 && index < 4" v-for="(item, index) in steps" :key="item.title" :class="index > 1 && index < 3? 'mx-auto' : ''")
              v-avatar(v-if="index < step" :color='$vuetify.theme.themes[$theme].primary500' size=32 class="step-selected")
                eva-icon.mt-1(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="16" height="16")
              v-avatar(v-else :color='step == index? $vuetify.theme.themes[$theme].primaryT08 : $vuetify.theme.themes[$theme].basic600T08' size=32 :class="step == index? 'step-selected' : 'step-normal'")
                .button-AA-small(:class="step == index? 'textColor--text' : 'textColorHint--text'") {{ index }}
              .c2.mt-1(:class="step == index? 'textColor--text' : 'textColorHint--text'") {{ item.title }}
        v-window(v-model="step")
          v-window-item(:value="0")
            div(v-if="authMember.id === company.primary_owner")
              div
                .p1.mb-3 Thanks for using our referral program, if you subscribe now, you can enjoy:
                .p1.mb-3 1. Monthly Contract Subscription : RM10 only (80% discount) for your first month subscription. (RM50→RM10)
                .p1.mb-3 Or
                .p1.mb-3 2. Yearly Contract Subscription: Save RM250 on your subscription (RM600→RM350)
            div(v-else)
              .p1 Please contact your admin and notify them to renew subscription.
          v-window-item(:value="1")
            // =========================================================================================================
            //  1. Choose your plan
            // =========================================================================================================
            .s2.mt-4 Your current account
            v-row.mt-2(align="center")
              v-col.py-0
                .p2(:class="isValidMemberCount ? 'primary400--text' : 'danger--text' ") {{ company.active_member_count }} active salespersons/agents
              v-col.shrink.py-0
                v-btn(v-if="!isValidMemberCount" @click="openEditMemberDialog = true" outlined small :color="$vuetify.theme.themes[$theme].danger" :style="{'background-color': $vuetify.theme.themes[$theme].dangerT08}")
                  .button-AA-tiny.danger500--text Manage
            v-row.mt-2(align="center")
              v-col.py-0
                .p2(:class="isValidFormCount ? 'primary400--text' : 'danger--text' ") {{ company.published_form_count }} published forms
              v-col.shrink.py-0
                v-btn(v-if="!isValidFormCount" @click="openEditFormDialog = true" outlined small :color="$vuetify.theme.themes[$theme].danger" :style="{'background-color': $vuetify.theme.themes[$theme].dangerT08}")
                  .button-AA-tiny.danger500--text Manage

            .main-container.my-6.mx-n4
              v-tabs(v-model="selectedCommitmentType" color="textColorAccent" :height="40" grow)

                v-tab.button-AA-medium(:style="{ 'color': selectedCommitmentType == 0? $vuetify.theme.themes[$theme].textColorAccent : $vuetify.theme.themes[$theme].basic600 }" ) Yearly contract
                v-tab.button-AA-medium(:style="{ 'color': selectedCommitmentType == 1? $vuetify.theme.themes[$theme].textColorAccent : $vuetify.theme.themes[$theme].basic600 }" ) Monthly Contract
              div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

            v-card.px-4.mb-4.pb-1(v-if="plan.price[form.commitment]" outlined v-for="(plan, index) in plans" :ripple="false" :key="plan.value" style="border:1px solid var(--v-basic300);" :color="index == recommendedPlanIndex ? $vuetify.theme.themes[$theme].successT08: $vuetify.theme.themes[$theme].basic600T08")
              div(@click="selectPlan(plan)")
                v-row
                  v-col
                    v-layout
                      .h5.textColor--text {{ plan.name }}
                      v-avatar.my-auto.ml-2(v-if="plan.selected" :color='$vuetify.theme.themes[$theme].textColorAccent' size=20)
                        eva-icon(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="16" height="16" style="margin-top:2px;")
                  v-col
                    .h4.textColor--text.text-right(v-if =" form.commitment==='monthly'") {{ offer ? plan.price['offer_' + 'monthly'] : plan.price[form.commitment] }}
                    .h4.textColor--text.text-right(v-else) {{  plan.price[form.commitment]/12 }}
                v-row.mb-3(no-gutters)
                  v-col
                    .p1.primary500--text {{ plan.detail.form }}
                    .p1.primary500--text {{ plan.detail.member }}
                  v-col
                    .p2.primary400--text.text-right RM per month
                    .p2.primary400--text.text-right(v-if="form.commitment === 'yearly'")
                      div(v-if="offer" ) We charge
                        span  RM {{ plan.price['offer_' +form.commitment] }} yearly
                        span(style="text-decoration: line-through;") RM {{ plan.price[form.commitment] }}
                      div(v-else) We charge
                        span  RM {{ plan.price[form.commitment] }} yearly
                    .p2.primary400--text.text-right(v-if="form.commitment === 'monthly' ")
                      div(v-if=" plan.value === 1 " ) Get this price for your first month (RM50→RM10)
                      div(v-else-if="plan.value !== 1") Get this price for 3 months
                    .s1.success500--text.text-right(v-if="index == recommendedPlanIndex") Recommended for you!

            .s1.mb-2 Add-ons
            v-card.pa-2.mb-4(outlined style="border:1px solid var(--v-basic300); border-radius:0")
              v-list-item.px-0.my-n2(v-if="formItems.length > 0")
                v-list-item-content
                  v-list-item-title.font-weight-bold Form
                  v-list-item-subtitle(v-if="form.commitment ==='monthly'") + RM3 each/month
                  v-list-item-subtitle(v-else) +RM3 each/month
                v-list-item-action
                  div(style="width: 80px;")
                    v-select(v-model="formAddOnCount" hide-details outlined dense :items="formItems" background-color="basic200")
              v-list-item.px-0.my-n2
                v-list-item-content
                  v-list-item-title.font-weight-bold Salesperson
                  v-list-item-subtitle(v-if="form.commitment ==='monthly'") + RM10 each/month
                  v-list-item-subtitle(v-else) + RM10 each/month
                v-list-item-action
                  div(v-if="memberItems.length > 0" style="width: 80px;")
                    v-select(v-model="memberAddOnCount" hide-details outlined dense :items="memberItems" background-color="basic200")
                  v-layout(v-else)
                    v-btn.my-auto(icon small @click="memberAddOnCount--" :disabled="memberAddOnCount < 1")
                      v-icon(color="primary") mdi-minus-circle
                    span.my-auto.text-center.colbox {{ memberAddOnCount }}
                    v-btn.my-auto(icon small @click="memberAddOnCount++")
                      v-icon(color="primary") mdi-plus-circle

          v-window-item(:value="2")
            // =========================================================================================================
            //  2. Select payment method
            // =========================================================================================================
            .h5.textColor--text.text-center Select payment method
            v-card.mt-8(flat outlined style="border:1px solid var(--v-basic300);")
              v-radio-group.mt-n1(v-model="selectedPaymentMethod" hide-details)
                v-layout(style="cursor: pointer" @click="selectedPaymentMethod = 'card'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text Credit or debit card
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="card" readonly)
                v-divider.basic300
                v-layout(:style="form.commitment === 'monthly' ? 'cursor: default' : 'cursor: pointer'" @click="form.commitment === 'monthly' ? '' : selectedPaymentMethod = 'fpx'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    BuildingBankIcon.ma-auto(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text Online banking
                        .c1.basic600--text(v-if="form.commitment === 'monthly'") For yearly contract only
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="fpx" readonly)

            v-card.pa-4.mt-8(v-if="selectedPaymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="selectedPaymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="selectedPaymentMethod === 'fpx'" )
                div.subtitle.mb-3 Choose bank for payment
                v-card.mb-12
                  FPXPicker(v-model="fpxBankCode")
          v-window-item.text-center(:value="3")
            // =========================================================================================================
            //  3. Confirm your subscription
            // =========================================================================================================
            .h5.textColor--text.text-center.mb-8 Confirm your subscription
            .h3.mt-6.textColor--text {{ selectedPlan.name }} Plan
            div.mt-4(v-if="offer && selectedPlan.value !== 4")
              .h1.text-center(v-if="form.commitment === 'yearly'") {{ selectedPlan.price.offer_yearly }}
                span(v-if="extraPrice")  + {{ extraPrice }}
              .h1.text-center(v-else-if="selectedPlan.value !== 4") {{ selectedPlan.price.offer_monthly }}
                span(v-if="extraPrice")  + {{ extraPrice }}
            .h1.text-center.mt-4(v-else) {{ totalPrice }}
              span(v-if="extraPrice")  + {{ extraPrice }}
            .p1.primary400--text.mt-4(v-if="form.commitment === 'monthly'") RM per month with monthly contract
            .p1.primary400--text.mt-4(v-else)  RM per year with yearly contract
            .extra.mt-4(v-if="formAddOnCount || memberAddOnCount")
              .s1.textColor--text(v-if="formAddOnCount") + {{ formAddOnCount }} extra form(s)
              .s1.textColor--text(v-if="memberAddOnCount") + {{ memberAddOnCount }} extra member(s)
            template(v-if="offer")
              .p2.text-center.success500--text.mt-4(v-if="form.commitment === 'yearly'")
                div(v-if="selectedPlan.value !== 1") Promo: FREE 1 month subscription (RM{{ offerPrice }}) for the first year
                div(v-else) Promo: RM250 discount for the first year
              .p2.text-center.success500--text.mt-4(v-else-if="selectedPlan.value !== 4")
                div(v-if="selectedPlan.value !== 1")
                  span(v-if="extraPrice") Promo: Pay only RM{{ offerPrice }} plus add-ons for the first 3 months and RM{{ totalPrice }} plus add-ons onward
                  span(v-else) Promo: Pay only RM{{ offerPrice }} for the first 3 months and RM{{ totalPrice }} onward
                div(v-if="selectedPlan.value === 1")
                  span(v-if="extraPrice") Promo: Pay only RM{{ selectedPlan.price.offer_monthly }} plus add-ons for the first month and RM{{ totalPrice }} plus add-ons onward
                  span(v-else) Promo: Pay only RM{{ selectedPlan.price.offer_monthly }} for the first month and RM{{ totalPrice }} onward
          v-window-item(:value="4")
            // =========================================================================================================
            //  4. Thank you
            // =========================================================================================================
            .h5.textColor--text.mb-8.text-center Subscription successful!
            v-container.text-center
              .p1.primary400--text Thank you for giving us the opportunity to help you grow further and bigger.
              .p1.primary400--text.mt-4 Let’s do this together.
              v-btn.mt-4(color="info500" dark @click="dialog=false" depressed height=32 )
                .button-AA-medium.basic100--text FINISH
          v-window-item(:value="5")
            // =========================================================================================================
            //  4. Payment failed
            // =========================================================================================================
            .h5.textColor--text.mb-8.text-center Payment failed
            v-container.text-center
              .p1.primary400--text The payment did not go through, please try again.
              v-btn.mt-4(color="info500" dark @click="retryPayment" depressed height=32 )
                .button-AA-medium.basic100--text Retry Payment

      v-divider.basic300(v-if="step == 1")
      v-card-actions.basic200.px-4(v-if="step == 1")
        v-col.pa-0
          .s2.primary400--text Selected plan:
          v-layout
            .p2.textColor--text {{ selectedPlan.name }} ({{ form.commitment }} contract)
            v-spacer
            .p2.textColor--text(v-if="selectedPlan.value !== 4") RM {{  offer ? selectedPlan.price['offer_' + form.commitment] : selectedPlan.price[form.commitment] }}
            .p2.textColor--text(v-else) {{ selectedPlan.price[form.commitment] }}
          v-layout(v-if="formAddOnCount")
            .p2.textColor--text + {{ formAddOnCount }} forms ({{ form.commitment }} add-ons)
            v-spacer
            .p2.textColor--text RM {{ formAddOnCount * (form.commitment == 'yearly'? 12 : 1) * 3 }}
          v-layout(v-if="memberAddOnCount")
            .p2.textColor--text + {{ memberAddOnCount }} salespersons ({{ form.commitment }} add-ons)
            v-spacer
            .p2.textColor--text RM {{ memberAddOnCount * (form.commitment == 'yearly'? 12 : 1) * 10 }}
          .p2.danger500--text(v-if="!isValidMemberCount || !isValidFormCount") Manage your account or select add-ons to fit this plan
      v-divider.basic400(v-if="step == 1")
      v-card-actions.pr-4(v-if="authMember.id === company.primary_owner && !company.contract" :class="step == 1? 'basic200' : ''")
        v-spacer
        template(v-if="step === 0")
          v-btn(v-if="company.status === 'Trial'" color='white' text @click="dialog = false")
            .button-Aa-medium.primary400--text Subscribe later
        v-btn(v-else-if="step !== 4 && step !== 5" color='white' text @click="step--")
          .button-Aa-medium.primary400--text Back
        template(v-if="step === 2")
          v-btn(v-if="selectedPaymentMethod == 'card'" color="info500" dark @click="nextStep" depressed :disabled="!form.card" height=32 )
            .button-AA-medium.basic100--text Next
          v-btn(v-else color="info500" @click="nextStep" depressed :disabled="!fpxBankCode" height=32 )
            .button-AA-medium.basic100--text Next
        v-btn(v-else-if="step === 3" @click="nextStep" color="info500" dark depressed :loading="isLoading" height=32 )
          .button-AA-medium.basic100--text Confirm and pay
        div(v-else-if="step === 4")
        div(v-else-if="step === 5")
        v-btn(v-else color="info500" dark @click="nextStep" depressed height=32 )
          .button-AA-medium.basic100--text Next
      v-card-actions(v-else-if="authMember.id === company.primary_owner && company.contract")
        v-spacer
        v-btn(v-if="step == 0" color="info500" dark @click="$router.push('/admin/billing/bills')" depressed height=32 )
          .button-AA-medium.basic100--text Next
      v-card-actions(v-else)
        v-spacer
        v-btn(v-if="company.status === 'Trial'" color='white' text @click="dialog = false")
          .button-Aa-medium.primary400--text Close

</template>

<script>
import { mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'
import SubscribeLaterModal from './SubscribeLaterModal'
import EditMemberModal from './EditMemberModal'
import EditFormModal from './EditFormModal'

export default {
  name: "SubscribeModal",
  components: { SubscribeLaterModal, CardList, EditMemberModal, EditFormModal, FPXPicker },
  props: ['open', 'company', 'volunteer', 'offer', 'paymentCallback'],
  data: (v) => ({
    metrics: null,
    subscribeLater: false,
    openEditMemberDialog: false,
    openEditFormDialog: false,
    selectedCommitmentType: 0,
    recommendedPlanIndex: 0,
    selected: true,
    step: 0,
    steps: [
      { title: v.volunteer ? 'Yezza Subscription' : 'Trial has ended'},
      { title: 'Select plan'},
      { title: 'Payment'},
      { title: 'Confirmation'},
      { title: 'Subscription Successful!'},
      { title: 'Payment Unsuccessful'}
    ],
    plans: [
      { name: 'Personal', value: 1, detail: { form: '1 form', member: '1 salesperson' }, form_count: 1, member_count: 1, price: { yearly: 444, monthly: 50, normal_yearly_price: 600, offer_yearly: 350,  offer_monthly: 10 }, max: { member: 4, form: 4 }, selected: false },
      { name: 'Business', value: 2, detail: { form: '5 forms', member: '5 salesperson' }, form_count: 5, member_count: 5, price: { yearly: 1764, monthly: 160, normal_yearly_price: 1920, offer_yearly: 1617, offer_monthly: 147  }, max: { member: 9, form: 9 }, selected: false },
      { name: 'Intelligence', value: 3, detail: { form: 'Unlimited forms', member: '10 salesperson' }, form_count: 0, member_count: 10, price: { yearly: 3564, monthly: 310, normal_yearly_price: 3720, offer_yearly: 3267, offer_monthly: 297 }, max: { member: null, form: null }, selected: false },
      { name: 'Personal', value: 4, detail: { form: '1 form', member: '1 salesperson' }, form_count: 1, member_count: 1, price: { yearly: '', monthly: 'FREE + 2%', offer_monthly: 'FREE + 2%' }, max: { member: 4, form: 4 }, selected: false }
    ],
    selectedPlan: null,
    commitments: [
      { text: 'Yearly contract', value: 'yearly' },
      { text: 'Monthly contract', value: 'monthly' }
    ],
    form: {
      company: v.company.id,
      plan: null,
      commitment: 'yearly',
      card: null
    },
    formAddOnCount: 0,
    memberAddOnCount: 0,
    isLoading: false,
    selectedPaymentMethod: null,
    fpxBankCode: null,
    retryPaymentLoading: false
  }),
  computed: {
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    totalAllowedMember () {
      return this.selectedPlan.member_count + this.memberAddOnCount
    },
    isValidMemberCount () {
      if (this.company.active_member_count > this.totalAllowedMember) {
        return false
      }
      return true
    },
    totalAllowedForm () {
      return this.selectedPlan.form_count + this.formAddOnCount
    },
    isValidFormCount () {
      if (this.selectedPlan.name == 'Intelligence') {
        return true
      }
      if (this.company.published_form_count > this.totalAllowedForm) {
        return false
      }
      return true
    },
    extraPrice () {
      let totalPrice = 0
      if (this.formAddOnCount) {
        if (this.form.commitment === 'monthly') {
          totalPrice += this.formAddOnCount * 3
        } else {
          totalPrice += this.formAddOnCount * 3 * 12
        }
      }
      if (this.memberAddOnCount) {
        if (this.form.commitment === 'monthly') {
          totalPrice += this.memberAddOnCount * 10
        } else {
          totalPrice += this.memberAddOnCount * 10 * 12
        }
      }
      return totalPrice
    },
    extraPriceNormal () {
      let totalPrice = 0
      if (this.formAddOnCount) {
        totalPrice += this.formAddOnCount * 36
      }
      if (this.memberAddOnCount) {
        totalPrice += this.memberAddOnCount * 120
      }
      return totalPrice
    },
    totalPrice () {
      if (!this.selectedPlan) return 0
      if (this.selectedPlan.value === 4) {
        return 'FREE + 2%'
      }
      let basePrice = this.selectedPlan.price.monthly
      if (this.form.commitment == 'yearly') {
        basePrice = this.selectedPlan.price.yearly
      }
      return basePrice
    },
    totalPriceAmount () {
      if (!this.selectedPlan) return 0
      let totalPrice = this.extraPrice
      if (this.selectedPlan.value !== 4) {
        if (this.form.commitment == 'yearly') {
          totalPrice += this.selectedPlan.price.yearly
        } else {
          totalPrice += this.selectedPlan.price.monthly
        }
      }
      return totalPrice
    },
    offerPrice () {
      return this.selectedPlan.price.yearly / 12
    },
    formItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Personal') {
        return [0,1,2,3]
      } else if (this.selectedPlan.name == 'Business') {
        return [0,1,2,3,4]
      }
      return []
    },
    memberItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Personal') {
        return [0,1,2,3]
      } else if (this.selectedPlan.name == 'Business') {
        return [0,1,2,3,4]
      }
      return []
    },
    windowTitle () {
      return this.steps[this.step].title
    },
    currentProgress () {
      return Math.ceil((this.step / this.steps.length) * 100)
    },
    yearlyRate () {
      return this.totalPrice / 12
    }
  },
  watch: {
    selectedCommitmentType (val) {
      // Set to Personal (normal) when changed to yearly contract
      if (val === 0 && this.selectedPlan.value === 4) {
        this.selectPlan(this.plans[1])
      }
      if (val === 1 && this.selectedPaymentMethod == 'fpx') {
        this.selectedPaymentMethod = 'card'
      }
      this.setCommitment(val)
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchMetrics()

    let index = 1
    if (this.company.published_form_count > this.plans[0].max.form) {
      index = 1
    }
    if (this.company.published_form_count > this.plans[1].max.form) {
      index = 2
    }
    if (this.company.active_member_count > this.plans[0].max.member) {
      index = 1
    }
    if (this.company.active_member_count > this.plans[1].max.member) {
      index = 2
    }
    this.plans[0].selected = true
    this.selectedPlan = this.plans[0]
    if (this.company.published_form_count - this.selectedPlan.form_count > 0 && index != 2) {
      this.formAddOnCount = this.company.published_form_count - this.selectedPlan.form_count
    }
    if (this.company.active_member_count - this.selectedPlan.member_count > 0) {
      this.memberAddOnCount = this.company.active_member_count - this.selectedPlan.member_count
    }
    this.recommendedPlanIndex = 0

    if (this.paymentCallback) {
      if (this.paymentCallback.success) {
        this.step = 4
      } else {
        this.step = 5
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    updatePlanValue (index, value) {
      this.plans[index].value = value
      if (this.selectedPlan.name === 'Personal') {
        this.selectedPlan.value = value
      }
    },
    fetchMetrics () {
      this.$axios.get(`/companies/${this.company.id}/sales/`)
        .then(resp => {
          this.metrics = resp.data
        })
        .catch(() => {})
    },
    setCommitment (index) {
      const selected = this.commitments[index]
      this.form.commitment = selected.value
    },
    selectPlan(plan) {
      this.plans.forEach(p => {
        if (p.value === plan.value) {
          p.selected = true
          this.selectedPlan = p
          if (this.selectedPlan.name == 'Intelligence') {
            this.formAddOnCount = 0
          } else if (this.formAddOnCount > (this.selectedPlan.max.form - this.selectedPlan.form_count)) {
            this.formAddOnCount = this.selectedPlan.max.form - this.selectedPlan.form_count
          }
          if (this.selectedPlan.name != 'Intelligence' && this.memberAddOnCount > (this.selectedPlan.max.member - this.selectedPlan.member_count)) {
            this.memberAddOnCount = this.selectedPlan.max.member - this.selectedPlan.member_count
          }
        } else {
          p.selected = false
        }
      })
    },
    nextStep () {
      if (this.step === 1) {
        if (!this.isValidMemberCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_member_count')])
          this.openEditMemberDialog = true
          return
        }
        if (!this.isValidFormCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_form_count')])
          this.openEditFormDialog = true
          return
        }
      }

      if (this.step === this.steps.length - 1) return

      if (this.step === 3) {
        if (this.selectedPaymentMethod === 'card') {
          this.subscribeByCard()
        } else if (this.selectedPaymentMethod === 'fpx') {
          this.subscribeByFpx()
        }
      } else {
        this.step++
        if (this.step === 2) {
          this.printSelection()
        }
      }
    },
    subscribeByCard () {
      this.form.plan = this.selectedPlan.value
      this.isLoading = true
      this.form.extra_form = this.formAddOnCount
      this.form.extra_member = this.memberAddOnCount
      if (this.offer) {
        if(this.selectedPlan.value===1){
        this.form.promo = 'pkp_2021_referral'
        }else{this.form.promo ='day_5_drip_campaign_promo'}
      }
      this.$axios.post(`/billing/contracts/`, this.form)
          .then(() => {
            this.$emit('subscribed')
            this.fetchCompany()
            this.step++
            this.trackGtag()
            this.trackPixel()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    subscribeByFpx () {
      this.form.plan = this.selectedPlan.value
      this.isLoading = true
      this.form.extra_form = this.formAddOnCount
      this.form.extra_member = this.memberAddOnCount
      this.form.bank_code = this.fpxBankCode
      if (this.offer) {
        if(this.selectedPlan.value===1){
        this.form.promo = 'pkp_2021_referral'
        }else{this.form.promo ='day_5_drip_campaign_promo'}
      }
      this.$axios.post(`/billing/contracts/yearly_subscription_request/`, this.form)
          .then(resp => {
            const data = resp.data
            setTimeout(() => {
              location.href = data.bill_url
            }, 1000)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request_contact')])
            this.isLoading = false
          })
    },
    fetchCompany () {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios.get(`/companies/${this.company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      } else {
        this.$axios.get(`/companies/${this.$subdomain}/`, { params: { use_slug: 'true' } })
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      }
    },
    retryPayment () {
      this.retryPaymentLoading = true
      location.href = `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.paymentCallback.billId}?auto_submit=true`
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.totalPriceAmount
        })
      })
    },
    trackPixel () {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Subscribe', {
        value: this.totalPriceAmount/this.$currency.multiplier,
        currency: this.$currency.code
      })
    },
    printSelection () {
      console.log(`Selected plan: ${this.selectedPlan.value}`)
    },
    gotoHome () {
      document.location.href = '/admin/dashboard'
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.slash-price {
  display: inline-block;
  text-decoration: none;
  position: relative;
}
.slash-price:after {
  content: '';
  display: block;
  width: 100%;
  height: 52%;
  position: absolute;
  top: 0;
  left: 0;
  border-bottom: 2px solid;
}

.v-card.payment-method-selected {
  border-color: #D11184;
}

.step-selected::after {
  border: 1px solid var(--v-primary500);
  border-radius: 50%;
  bottom: 0;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
}

.step-selected.avatar--tile::after {
  border-radius: 3px;
}

.step-normal::after {
  border: 1px solid var(--v-basic600);
  border-radius: 50%;
  bottom: 0;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
}

.step-normal.avatar--tile::after {
  border-radius: 3px;
}

.main-container {
  position: relative;
}

.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>
